export const LAYOUT_MAX_WIDTH = 980;

export const BACKEND_SIDEBAR_SECTION = {
  id: 'backend-servers',
  title: 'BackEnd Servers',
};

/** Static app rows shown in the monitoring table. */
export const BACKEND_APPS = [
  { id: 'notification', name: 'Notification BackEnd' },
  { id: 'customer', name: 'Customer-BackEnd' },
  { id: 'kitchen', name: 'Kitchen-BackEnd' },
  { id: 'regional-branch', name: 'RegionalBranch-BackEnd' },
  { id: 'driver', name: 'Driver-BackEnd' },
];

export const ENV_COLUMNS = [
  {
    key: 'production',
    label: 'Production',
    hasInfo: true,
    tooltip: 'Production environment health status.',
  },
  {
    key: 'uat',
    label: 'UAT',
    hasInfo: true,
    tooltip: 'User acceptance testing environment health status.',
  },
  {
    key: 'develop',
    label: 'Develop',
    hasInfo: true,
    tooltip: 'Development environment health status.',
  },
  { key: 'test', label: 'Test', hasInfo: false },
];
